import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { EligibilityStatusService } from 'application/eligibility-status/services';
import { resolveColumns } from 'application/facility/util/resolveColumns';
import { action } from 'mobx';

@applicationContext
class EligibilityStatusListViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const service = new EligibilityStatusService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'eligibility-status',
            autoInit: true,
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            },
            routes: {
                create: () => this.rootStore.routerStore.goTo(
                    'master.app.main.eligibility-status.create'
                ),
                edit: item => {
                    this.setChildNavigationTitle(i =>
                        i.id === item.id,
                        () => item.name
                    );
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.eligibility-status.edit',
                        { id: item.id }
                    )
                },
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await service.find({
                            ...params
                        });
                        return response.data;
                    },
                    delete: async (item) => {
                        await service.delete(item);
                    }
                }
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'name',
                    title: 'ELIGIBILITY_STATUS.LIST.COLUMNS.NAME',
                    width: 400
                },
                {
                    key: 'description',
                    title: 'ELIGIBILITY_STATUS.LIST.COLUMNS.DESCRIPTION'
                }
            ]),
            actions: {
                onEdit: async (item) => this.routes.edit(item),
                onDelete: async (item) => this.deleteResource(item)
            }
        }));
    }

    @action.bound
    notifySuccessDelete() {
        this.rootStore.notificationStore.success('ELIGIBILITY_STATUS.LIST.ACTIONS.SUCCESS_DELETE');
    }
}

export default EligibilityStatusListViewStore;
